import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'app/implementation/shared/shared.module';

import { FxBreadComponent } from './fx-bread/fx-bread.component';
import { FooterComponent } from './footer/footer.component';
import { Fxed020MenuComponent } from './fxed020-menu/fxed020-menu.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  declarations: [
    FxBreadComponent,
    FooterComponent,
    Fxed020MenuComponent
  ],
  exports: [
    FxBreadComponent,
    FooterComponent,
    Fxed020MenuComponent
  ],
  entryComponents: [
    FxBreadComponent,
    FooterComponent,
    Fxed020MenuComponent
  ]
})
export class Fxed020SharedModule { }
